// ComunicacionUI — piezas compartidas de la sección COMUNICACIÓN (26-jul-2026).
// La visión de Nico: "una agencia de comunicación que contraté, con agentes que
// trabajan para mí". Tres agentes: Redes (B2C/IG), Empresas (B2B) y Folletería.
// Regla del proyecto (feedback_agente_sin_nombres_equipo): los agentes NO llevan
// nombres de persona — se presentan por rol, como puestos de una agencia.

import { Link } from 'react-router-dom'

export const AGENTES_COM = {
  redes: {
    slug: 'redes',
    emoji: '📱',
    nombre: 'Agente de Redes',
    rol: 'B2C · Instagram orgánico',
    // 26-jul: el escritorio del agente se partió en dos pantallas numeradas
    // (1 · Plan semanal y 2 · Publicar); la vieja /redes redirige a /plan.
    to: '/admin/comunicacion/plan',
    desc: 'Piensa el plan semanal (Estratega, Opus 4.8), produce las piezas (Gerente, Sonnet) y las publica solo cuando llega su horario (Publisher, cron 15 min). Vos solo aprobás: primero el plan (1), después cada pieza (2).',
    // agentes_runs.agente que componen este "puesto"
    runSlugs: ['estratega-semanal', 'gerente-marketing', 'publisher-marketing', 'ig-metricas-pull'],
    crones: 'Estratega dom 20:00 · Publisher cada 15 min · Métricas IG 22:00',
  },
  empresas: {
    slug: 'empresas',
    emoji: '💼',
    nombre: 'Agente de Empresas',
    rol: 'B2B · Google + mail + volantes (NO Instagram)',
    to: '/admin/comunicacion/empresas',
    desc: 'Capta comercios, oficinas y administradoras: mails de prospección, briefs de pauta B2B para Google y guiones de volante. B2B no va por IG: un administrador de edificios no compra por Instagram.',
    runSlugs: ['agente-empresas'],
    crones: 'Corre martes 09:00 Mvd',
  },
  folleteria: {
    slug: 'folleteria',
    emoji: '📄',
    nombre: 'Folletería',
    rol: 'Material impreso · QR con tracking',
    to: '/admin/comunicacion/folleteria',
    desc: 'Folletos A5 (vecinos + empresas), builder de volantes para edificios y lotes con QR trackeable (limpack.uy/r/{slug}). Cada papel repartido se mide en escaneos y pedidos.',
    runSlugs: [],
    crones: 'Manual · imprimís y repartís vos',
  },
}

export function fmtRun(iso) {
  if (!iso) return 'sin corridas'
  return new Date(iso).toLocaleString('es-UY', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })
}

// Hero de página de agente: quién es, qué hace, estado del último run.
export function AgenteHero({ agente, ultimaCorrida, extra }) {
  return (
    <div className="com-hero">
      <div className="com-hero-avatar">{agente.emoji}</div>
      <div className="com-hero-body">
        <div className="com-hero-eyebrow">COMUNICACIÓN · AGENCIA LIMPACK</div>
        <h1 className="com-hero-nombre">{agente.nombre}</h1>
        <div className="com-hero-rol">{agente.rol}</div>
        <p className="com-hero-desc">{agente.desc}</p>
        <div className="com-hero-meta">
          <span>⏱ {agente.crones}</span>
          <span>· Última corrida: <strong>{fmtRun(ultimaCorrida)}</strong></span>
          {extra}
        </div>
      </div>
      <Link to="/admin/comunicacion" className="com-hero-back">← Hub</Link>
    </div>
  )
}

// CSS compartido de toda la sección (paleta oficial: Navy/Teal/Bone/Gold).
export const COM_CSS = `
  .com-wrap { max-width: 1160px; display: flex; flex-direction: column; gap: 16px; }
  .com-card {
    background: #fff; border: 1px solid #E5E7EB; border-radius: 14px;
    padding: 16px 18px; box-shadow: 0 1px 3px rgba(26,52,97,.05);
  }
  .com-card-head { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 12px; flex-wrap: wrap; }
  .com-card-title { font-size: 15px; font-weight: 800; color: #1A3461; margin: 0; }
  .com-card-sub { font-size: 12px; color: #6B7280; }

  .com-hero {
    display: flex; gap: 16px; align-items: flex-start;
    background: linear-gradient(135deg, #1A3461 0%, #12264a 100%);
    border-radius: 16px; padding: 20px 22px; color: #fff; position: relative;
  }
  .com-hero-avatar {
    width: 58px; height: 58px; border-radius: 16px; flex-shrink: 0;
    background: rgba(0,168,181,.18); border: 1px solid rgba(0,168,181,.4);
    display: flex; align-items: center; justify-content: center; font-size: 28px;
  }
  .com-hero-eyebrow { font-size: 9.5px; font-weight: 800; letter-spacing: .16em; color: #C5A059; }
  .com-hero-nombre { font-size: 22px; font-weight: 900; margin: 2px 0 0; letter-spacing: -.02em; }
  .com-hero-rol { font-size: 12.5px; font-weight: 700; color: #5EE8F0; margin-top: 2px; }
  .com-hero-desc { font-size: 12.5px; color: rgba(255,255,255,.75); margin: 8px 0 0; max-width: 640px; line-height: 1.5; }
  .com-hero-meta { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px; font-size: 11px; color: rgba(255,255,255,.6); }
  .com-hero-meta strong { color: #fff; }
  .com-hero-back {
    position: absolute; top: 14px; right: 16px; font-size: 11.5px; font-weight: 700;
    color: rgba(255,255,255,.7); text-decoration: none;
  }
  .com-hero-back:hover { color: #fff; }

  .com-btn {
    border: 0; border-radius: 8px; padding: 8px 14px; font-size: 12.5px; font-weight: 700;
    cursor: pointer; font-family: inherit; transition: opacity .12s;
  }
  .com-btn:disabled { opacity: .55; cursor: default; }
  .com-btn-primary { background: #00A8B5; color: #fff; }
  .com-btn-green { background: #10B981; color: #fff; }
  .com-btn-ghost { background: #F1F5F9; color: #1A3461; border: 1px solid #E2E8F0; }
  .com-btn-danger { background: transparent; color: #DC2626; border: 1px solid #FCA5A5; }

  .com-msg { padding: 8px 12px; border-radius: 8px; font-size: 12.5px; }
  .com-msg-ok { background: #DCFCE7; color: #064E3B; }
  .com-msg-err { background: #FEE2E2; color: #991B1B; }

  .com-empty { padding: 18px; text-align: center; color: #6B7280; font-size: 12.5px; }
  .com-empty strong { color: #1A3461; display: block; margin-bottom: 2px; }

  .com-pill {
    display: inline-flex; align-items: center; gap: 4px;
    font-size: 10px; font-weight: 800; letter-spacing: .04em;
    padding: 2px 8px; border-radius: 999px; text-transform: uppercase;
  }
  .com-pill-teal { background: #E0F4F6; color: #00666B; }
  .com-pill-gold { background: #FBF3E2; color: #8a6d2f; }
  .com-pill-green { background: #D1FAE5; color: #065F46; }
  .com-pill-gray { background: #F1F5F9; color: #475569; }
  .com-pill-red { background: #FEE2E2; color: #991B1B; }

  @media (max-width: 700px) {
    .com-hero { flex-direction: column; }
    .com-hero-back { position: static; order: -1; }
  }
`
